<template>
  <div>
    <MainNavbar></MainNavbar>
    <b-container>
      <b-card class="my-4" no-body>
        <b-card-body>
          <b-row>
            <b-col>
              <FormAlert></FormAlert>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-container>
    <MainFooter></MainFooter>
  </div>
</template>
<script>
import MainNavbar from '@/components/MainNavbar.vue';
import MainFooter from '@/components/MainFooter.vue';
import FormAlert from '@/components/FormAlert.vue';

export default {
  name: 'NewCase',
  components: {
    MainNavbar,
    MainFooter,
    FormAlert,
  },
  methods: {
    addFile() {
      this.files.push(this.file);
      this.file = null;
    },
  },
};
</script>
<style>
.satmed-social-media {
  font-size: 2.7rem;
  cursor: pointer;
  transition: 0.5s ease;
}
.satmed-social-media:hover {
  color: #009ee3;
}
</style>
